import { SlideDirection } from '@/hooks';
import { AnimationPreset } from '@/types/animations';

export const CIRCLE_RING_ANIMATION = {
  DIRECTION: SlideDirection.Left,
  DISTANCE: 400,
  SPRING_CONFIG: AnimationPreset.GENTLE,
  DURATION_IN_FRAMES: 15,
  REVEAL_SPEED: 0.2,
  SLIDE_SPEED: 0.5,
} as const;

export const DECORATIVE_YEAR_ANIMATION = {
  DIRECTION: SlideDirection.Top,
  DISTANCE: 1000,
  SPRING_CONFIG: AnimationPreset.GENTLE,
  DURATION_IN_FRAMES: 80,
} as const;

export const TEXT_ANIMATIONS_CONFIG = {
  STAGGER: 20,
  SPRING_CONFIG: AnimationPreset.BOUNCY,
  START_FRAME: 40,
} as const;

export const LOGO_ANIMATION_CONFIG = {
  DURATION_IN_FRAMES: 42,
  SPRING_CONFIG: {
    damping: 200,
    mass: 1.2,
    stiffness: 80,
  },
} as const;
